<template><div><h1>$t is not defined</h1>
<p>一般是两个原因：</p>
<h2>cnpm 导致的问题</h2>
<p>如果是直接使用模板后并且使用 <code>cnpm</code> 报错，请升级到 <code>vux-loader@1.0.58</code>。</p>
<p>该问题出现原因是 <code>cnpm</code> 安装后 <code>node_modules</code> 里的模块为快捷方式，而 <code>vux-loader</code> 之前版本没有考虑到这一特殊情况。</p>
<h2>未正确配置动态 i18n</h2>
<p>demo例子使用<code>$t</code>是因为demo启用了<code>i18n</code>，如果你没有使用<code>vuex-i18n</code>等相关<code>i18n</code>插件，请不要在代码中使用<code>$t</code>函数</p>
</div></template><script>
export default {
  head: {"title":"$t is not defined | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// $t-is-not-defined-13.vue?82f96440